module.exports = __webpack_public_path__ + "img/sym-cart-01.5f2a2338.svg";